import {useCallback, useEffect, useRef, useState} from 'react';

import {useBlocker} from 'react-router-dom';

import useProfile from '../../providers/useProfile';

const useSaveViewBeforeLeavingReport = () => {
  const {saveOnboardingVideoProgression, currentFlowStep, selectedFlow} = useProfile();

  const [canNavigate, setCanNavigate] = useState(false);
  const [shouldProceed, setShouldProceed] = useState(false);

  const save = useCallback(async () => {
    if (!selectedFlow) return;

    saveOnboardingVideoProgression(currentFlowStep.step_id, currentFlowStep.position);
  }, [saveOnboardingVideoProgression, currentFlowStep.step_id, selectedFlow]);

  const shouldBlock = useCallback(
    ({currentLocation, nextLocation}) => {
      const pathsAreDifferent = currentLocation.pathname !== nextLocation.pathname;
      return !canNavigate && pathsAreDifferent;
    },
    [canNavigate]
  );

  const blocker = useBlocker(shouldBlock);
  const blocked = blocker.state === 'blocked';

  useEffect(() => {
    (async () => {
      if (blocked && !shouldProceed) {
        await save();
        setShouldProceed(true);
      }
    })();
  }, [blocked, shouldProceed]);

  useEffect(() => {
    if (blocked && shouldProceed) {
      setCanNavigate(true);
      blocker.proceed();
      setShouldProceed(false);
      setCanNavigate(false);
    }
  }, [blocked, shouldProceed, blocker]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      save();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);
};

export default useSaveViewBeforeLeavingReport;
